export default function FeaturesTwo(){
    return(
        <>
            <section className="core-feature-area pt-120 pt-md-60 pt-xs-60 pb-100 pb-md-30 pb-xs-30 home-4">
			<div className="container">
				<div className="row">
					<div className="col-lg-12">
						<div className="section-title text-center mb-55">
							<p className="lh-1 mb-10">CORE FEATURES</p>
							<h2 className="sect-title">We Served as your wish for success</h2>
						</div>
					</div>
				</div>
				<div className="row gx-0">
					<div className="col-lg-6 col-md-12">
						<div className="core-feature4">
							<div className="core-content">
								<div className="core-icon">
									<span className="icon"><i aria-hidden="true" className="far fa-credit-card"></i></span>
								</div>
								<div className="core-text">
									<h3>Digital Product</h3>
									<p>Nostrum officia tempus occaecat aut vero muse platea, velit tenetur diam elit
										eaque! Ultrices justo, illum dui.</p>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-6 col-md-12">
						<div className="core-feature4">
							<div className="core-content">
								<div className="core-icon">
									<span className="icon"><i aria-hidden="true" className="fas fa-laptop-code"></i></span>
								</div>
								<div className="core-text">
									<h3>Software Updater</h3>
									<p>Nostrum officia tempus occaecat aut vero muse platea, velit tenetur diam elit
										eaque! Ultrices justo, illum dui.</p>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-6 col-md-12">
						<div className="core-feature4">
							<div className="core-content">
								<div className="core-icon">
									<span className="icon"><i aria-hidden="true" className="far fa-file-code"></i></span>
								</div>
								<div className="core-text">
									<h3>Web Development</h3>
									<p>Nostrum officia tempus occaecat aut vero muse platea, velit tenetur diam elit
										eaque! Ultrices justo, illum dui.</p>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-6 col-md-12">
						<div className="core-feature4">
							<div className="core-content">
								<div className="core-icon">
									<span className="icon"><i aria-hidden="true" className="far fa-grin-stars"></i></span>
								</div>
								<div className="core-text">
									<h3>
										Web Design</h3>
									<p>Nostrum officia tempus occaecat aut vero muse platea, velit tenetur diam elit
										eaque! Ultrices justo, illum dui.</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
        </>
    )
}